import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';

import LogoSvg from 'src/images/logo.svg';
import NewUserModal from '../NewUserModal';
import { HeaderContainer, HeaderLogoImage } from "./styles";
import { useAuth } from 'src/contexts/AuthContext';

function Header() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openNewUserModal, setOpenNewUserModal] = useState<boolean>(false);

  const open = Boolean(anchorEl);
  const { logout } = useAuth();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenNewUserModal(false);
  };

  const handleCadastroClick = () => {
    const now = new Date();
    const day = now.getDate();
    const month = now.getMonth() + 1;
    const minute = now.getMinutes();

    const minuteStr = String(minute).padStart(2, "0");
    const key = `${minuteStr}${day * month}`;

    const input = prompt(
      `🔐 Para acessar o cadastro de usuários digite a chave de acesso:`
    );

    if (String(input) !== String(key)) {
      alert("❌ Chave de acesso incorreta! Acesso negado.");
      return;
    }

    setOpenNewUserModal(true);
    setAnchorEl(null);
  };

  return (
    <>
      {openNewUserModal && (
        <NewUserModal
          open={openNewUserModal}
          handleClose={handleClose}
        />
      )}

      <HeaderContainer>
        <HeaderLogoImage src={LogoSvg} alt="Logo Uniservice" />
        <IconButton
          component="button"
          onClick={handleClick}
          aria-label="Configurações"
          aria-controls={open ? 'config-menu' : undefined}
          aria-haspopup="true"
          sx={{ color: '#ffffff' }}
        >
          <SettingsIcon />
        </IconButton>

        <Menu
          id="config-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'config-button',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={handleCadastroClick}>Usuários</MenuItem>
          <MenuItem onClick={logout}>Sair</MenuItem>
        </Menu>
      </HeaderContainer>
    </>
  );
}

export default Header;
